export const toLocalDate = (isoDateString: string): string => {
  const date = new Date(isoDateString);
  return date.toLocaleDateString();
};

export const toLocalDateTime = (isoDateString: string): string => {
  const date = new Date(isoDateString);
  return date.toLocaleTimeString();
};
